window.setAuctionState = function setAuctionState(auction_id, auction_state) {
  // console.log(auction_state);
  const auctionCards = document.querySelectorAll(
    `[data-auction-id="${auction_id}"]`
  );

  auctionCards.forEach((card) => {
    const timeLeftDiv = card.querySelector(".time_left");
    if (!timeLeftDiv) return;
    
    timeLeftDiv.classList.remove('won', 'lost', 'ended', 'active', 'outbid', 'not_loaded');
    const secondDiv = card.querySelector(".time_left.second");
    if (secondDiv) secondDiv.remove();

    const newStateInfo = {
      "Auction Won": {
        className: "won",
        innerHTML: `
          <img src="//www.emedals.com/cdn/shop/t/103/assets/auction-won.png?v=63374821140401959361746716562" loading="lazy" width="15" height="15" />
          <span class="time_left_text">Auction Won</span>
        `,
      },
      "Auction Lost": {
        className: "lost",
        innerHTML: `
          <img src="//www.emedals.com/cdn/shop/t/103/assets/auction-lost.png?v=142890051665423626681746716561" loading="lazy" width="15" height="15" />
          <span class="time_left_text">Auction Lost</span>
        `,
      },
      "Auction Ended": {
        className: "ended",
        innerHTML: `
          <img src="//www.emedals.com/cdn/shop/t/103/assets/auction-ended.png?v=3743771452866791851746716560" loading="lazy" width="15" height="15" />
          <span class="time_left_text">Auction Ended</span>
        `,
      },
      "Winning": {
        className: "active",
      },
      "Outbid": {
        className: "outbid",
      },
    };

    const newState = newStateInfo[auction_state];

    if (newState) {
      if (auction_state === "Winning" || auction_state === "Outbid") {
        const newSecondDiv = document.createElement("div");
        newSecondDiv.classList.add("time_left", "second", newState.className);
        newSecondDiv.innerHTML = `
          <div class="ring-container">
            <div class="circle"></div>
            <div class="ringring"></div>
          </div>
          <span class="time_left_text">${auction_state}</span>
        `;
        timeLeftDiv.parentNode.insertBefore(
          newSecondDiv,
          timeLeftDiv.nextSibling
        );
      } else {
        timeLeftDiv.classList.add(newState.className);
        timeLeftDiv.innerHTML = newState.innerHTML;
      }
    }
  });
};

var auctionProductIds = [];
var auctionGTRIds = [];
var intervals = {};
var timeZoneAbbreviation = "";
var debounceTimeout = null;
var fetchedAuctionIds = new Set();

function debounceFetchAuctions() {
  if (debounceTimeout) clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    const auctionCards = document.querySelectorAll("auctions-card:not(#auction-card-template auctions-card)");
    let newAuctionIds = [];
    auctionCards.forEach(card => {
      const auctionId = parseInt(card.dataset.auctionId);
      if (Number.isInteger(auctionId) && !fetchedAuctionIds.has(auctionId)) {
        newAuctionIds.push(auctionId);
      }
    });
    if (newAuctionIds.length > 0) {
      // Mark these IDs as fetched to avoid duplicate calls
      newAuctionIds.forEach(id => fetchedAuctionIds.add(id));

      // removing Auction Ids which are GTR products. So that I can show it in Home Custom Featured Section,.
      if (template == 'index') {
        newAuctionIds = newAuctionIds.filter((id) => !auctionGTRIds.includes(id));
      }
      const strIds = newAuctionIds.join(",");
      // Fetch auction info for these new IDs
      window.globalApi.getTimeZoneAbbreviation().then(abbr => {
        timeZoneAbbreviation = abbr;
        // Use any auctions-card instance to call getByProduct
        const anyCard = document.querySelector("auctions-card");
        if (anyCard && typeof anyCard.getByProduct === "function") {
          anyCard.getByProduct(strIds);
        }
      });
    }
  }, 400);
}

// Observe for new auction cards being added to the DOM
const observer = new MutationObserver(debounceFetchAuctions);
observer.observe(document.body, { childList: true, subtree: true });

// Optionally, trigger once on initial load
window.addEventListener("DOMContentLoaded", debounceFetchAuctions);

class AuctionsCard extends HTMLElement {
  constructor() {
    super();
    const product_id = this.dataset.productId;
    const auction_id = parseInt(this.dataset.auctionId);

    const wishlistButton = this.querySelector('[data-action="addToWishlist"]');
    const activeWishListButton = this.querySelector(
      '[data-action="removeToWishlist"]'
    );

    const template = document.querySelector('#MainContent').dataset.template;

    const _this = this;

    const is_gtr = this.dataset.isGtr;

    // console.log(is_gtr, product_id, 'is_gtr');

    if (wishlistButton) {
      wishlistButton.addEventListener("click", function (e) {
        const customerID = getCustomerId();

        if (customerID) {
          e.preventDefault();
          _this.addProductToWishList(
            product_id,
            wishlistButton,
            activeWishListButton
          );
        } else {
          window.history.pushState({}, null, "/#signin");
        }
      });
    }

    if (activeWishListButton) {
      activeWishListButton.addEventListener("click", function () {
        _this.removeFromWishList(
          product_id,
          wishlistButton,
          activeWishListButton
        );
      });
    }

    console.log(product_id, auction_id, "AUCTION CARDS");

    _this.gtrProduct(_this, is_gtr, auction_id, template);
    // Remove the old init logic that relied on auctionProductIds.length === auctionCards.length
    // _this.init(auction_id, template);
    // Instead, just call debounceFetchAuctions to handle this card
    debounceFetchAuctions();
  }

  async gtrProduct(product, is_gtr_bool, auction_id, template) {
    const parent_li = product.parentElement;
    const canBypass = localStorage.getItem('bypass') || false;
    if (is_gtr_bool == 'true') {
      
      // only for the index/home page GTR products will be removed GLOBALLY, even bypass is true.
      if (template == 'index') {
        parent_li.remove(); 
        auctionGTRIds.push(auction_id);
        return; 
      }

      const restricted = await window.globalApi.isCountryRestricted();
      if (restricted && canBypass == 'false') {
        auctionGTRIds.push(auction_id);
        parent_li.remove();
      }
    }
  }

  async init(auction_id) {
    if (Number.isInteger(auction_id)) auctionProductIds.push(auction_id);
    
    // removing Auction Ids which are GTR products. So that I can show it in Home Custom Featured Section,.
    const canBypass = localStorage.getItem('bypass') || false;
    if (template == 'index') {
      auctionProductIds = auctionProductIds.filter((id) => !auctionGTRIds.includes(id));
    }

    const auctionCards = document.querySelectorAll("auctions-card:not(#auction-card-template auctions-card)");
    console.log("ID-> ",auctionProductIds, " cards length -> ",auctionCards.length);
    if (auctionProductIds.length === auctionCards.length && auctionCards.length > 0) {
      const strIds = auctionProductIds.join(",");
      timeZoneAbbreviation = await window.globalApi.getTimeZoneAbbreviation();
      await this.getByProduct(strIds);
      auctionProductIds = [];
    }
  }

  async getByProduct(auction_ids) {
    await window.auctionApi
      .getByAuctionIds(auction_ids, window.getCustomerId())
      .then((response) => response.text())
      .then(async (result) => {
        const resultJson = await JSON.parse(result);
        this.data = resultJson.data;
        // console.log('auction data', this.data);
        if (this.data.length) {
          this.data.forEach((auction) => {
            const auctionId = auction.id;
            const productCard = document.querySelectorAll(
              `[data-product-id="${auction.attributes.platform_product_id}"]`
            );
            productCard.forEach((card) => {
              if (card.localName === "auctions-card") {
                const endDate = auction.attributes.end_date;
                card.dataset.dataEndDate = endDate;
                const currentPrice = auction.attributes.current_price;
                this.setEndDate(auctionId, endDate);
                const bidsCount = auction.attributes.bids_count;
                const auctionEnded = auction.attributes.auction_has_ended;
                const currentUserBid = auction.attributes.current_user_bid;
                this.setBidCount(auctionId, bidsCount);
                const bidState = this.getAuctionState(
                  currentUserBid,
                  auctionEnded
                );
                if (!auctionEnded) {
                  this.setOnlyAuctionTime(endDate, auctionId);
                }
                if (auctionEnded) {
                  this.hidePlaceBidButton(auctionId);
                }
                this.setCurrentPrice(auctionId, currentPrice, auctionEnded);
                window.setAuctionState(auctionId, bidState);
                this.querySelector(".time_left").classList.remove("hidden");
                this.querySelector(".time_left").classList.add("desktop_view");
                // this.querySelector(".place_bid").style.display = "";
                // this.querySelector(".date_badge").style.display = "";
                // this.querySelector(".bid-count").style.display = "";
              }
            });
            this.setPusherInstances(auctionId);
          });
        } else {
          this.querySelector(".time_left").classList.add("hidden");
          this.querySelector(".time_left").classList.remove("desktop_view");
          this.querySelector(".place_bid").style.display = "none";
          this.querySelector(".date_badge").style.display = "none";
          this.querySelector(".bid-count").style.display = "none";
        }
      })
      .catch((error) => console.log("error", error));
  }
  setPusherInstances(auction_id) {
    const that = this;
    window.pusherInstance
      .subscribe(`auction-${auction_id}`)
      .bind("auction_bid_update", async function (data) {
        // console.log(data);
        const content = {
          title: data.event,
          productImgUrl: data.product_image_url,
          name: data.product_name,
          productUrl: data.product_url,
        };

        try {
          const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
          if (shouldShowNotification) {
            window.showToast('info', content);
          } else {
            console.log("GTR restrictions applied. Not showing notification.");
          }
        } catch (error) {
          console.error("Error checking GTR accessibility: ", error);
          window.showToast('info', content);
        }
        // window.showToast("info", content);
        that.setBidCount(auction_id, data.bid_count);
        that.setCurrentPrice(auction_id, data.current_price);
        if (data.bid_count === 1) {
          window.setAuctionState(auction_id, "Winning");
        }
      });

    window.pusherInstance
      .subscribe(`auction-${auction_id}`)
      .bind("auction_extended", async function (data) {
        // console.log(data);
        const content = {
          title: data.event,
          productImgUrl: data.product_image_url,
          name: data.product_name,
          productUrl: data.product_url,
        };

        try {
          const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
          if (shouldShowNotification) {
            window.showToast('info', content);
          } else {
            console.log("GTR restrictions applied. Not showing notification.");
          }
        } catch (error) {
          console.error("Error checking GTR accessibility: ", error);
          window.showToast('info', content);
        }
        // window.showToast("info", content);
        that.setOnlyAuctionTime(data.new_date, auction_id);
        that.setEndDate(auction_id, data.new_date);
      });

    window.pusherInstance
      .subscribe(`auction-${auction_id}`)
      .bind("auction_ended", async function (data) {
        // console.log(data);
        const content = {
          title: data.event,
          productImgUrl: data.product_image_url,
          name: data.product_name,
          productUrl: data.product_url,
        };

        try {
          const shouldShowNotification = await window.globalApi.GTRProductNotification(data.product_url);
          if (shouldShowNotification) {
            window.showToast('info', content);
          } else {
            console.log("GTR restrictions applied. Not showing notification.");
          }
        } catch (error) {
          console.error("Error checking GTR accessibility: ", error);
          window.showToast('info', content);
        }
        // window.showToast("info", content);
        window.setAuctionState(auction_id, "Auction Ended");
        that.hidePlaceBidButton(auction_id);
      });
  }
  getAuctionState(current_user_bid, auction_has_ended) {
    let bid_state = "";

    if (!auction_has_ended) {
      bid_state = "Auction Live";
    } else {
      bid_state = "Auction Ended";
    }

    if (current_user_bid) {
      const isOutBid = current_user_bid.outbid;
      if (!auction_has_ended) {
        if (isOutBid) {
          bid_state = "Outbid";
        } else {
          bid_state = "Winning";
        }
      } else {
        if (isOutBid) {
          bid_state = "Auction Lost";
        } else {
          bid_state = "Auction Won";
        }
      }
    }
    return bid_state;
  }
  getAuctionRemainingTime(end_date) {
    var dateStart = new Date();
    var dateEnd = new Date(end_date);
    if (dateEnd <= dateStart) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return this.getDateDiffInDHM(dateStart, dateEnd);
  }
  setOnlyAuctionTime(endDate, auction_id) {
    const auctionCards = document.querySelectorAll(
      `[data-auction-id="${auction_id}"]`
    );
    auctionCards.forEach((card) => {
      if (card) {
        let timeLeftDiv = card.querySelector(".time_left");
        if (timeLeftDiv) {
          timeLeftDiv.classList.remove("not_loaded");
          timeLeftDiv.classList.add("first");
          timeLeftDiv.innerHTML = `<img src="//www.emedals.com/cdn/shop/t/103/assets/timelapse.png?v=66935396978533379061746716703" loading="lazy" width=15 height=15 /><span class="time_left_text"></span>`;
          const { days, hours, minutes, seconds } =
            this.getAuctionRemainingTime(endDate);
          this.setCountdownTimeHtml(card, days, hours, minutes, seconds);
          if (intervals[auction_id]) clearInterval(intervals[auction_id]);
          intervals[auction_id] = setInterval(() => {
            const { days, hours, minutes, seconds } =
              this.getAuctionRemainingTime(endDate);
            if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
              clearInterval(intervals[auction_id]);
              intervals[auction_id] = null;
            }
            // Display the countdown timer
            this.setCountdownTimeHtml(card, days, hours, minutes, seconds);
          }, 1000);
        }
      }
    });
  }
  setCountdownTimeHtml(auctionCard, days, hours, minutes, seconds) {
    let timeLeftTextArr = auctionCard.querySelectorAll(
      ".time_left:not(.second) .time_left_text"
    );
    timeLeftTextArr.forEach((El) => {
      El.innerHTML = "";
      if (days > 0) {
        El.innerHTML = days + "D " + hours + "H left";
      } else if (hours > 0) {
        El.innerHTML = hours + "H " + minutes + "M left";
      } else {
        El.innerHTML = minutes + "M " + seconds + "S left";
      }
    });
  }
  setEndDate(auction_id, end_date) {
    const auctionCards = document.querySelectorAll(
      `[data-auction-id="${auction_id}"]`
    );
    auctionCards.forEach((card) => {
      const dateEls = card.querySelector("div.start_date");
      var dateEnd = new Date(end_date);
      const date = dateEnd.toLocaleDateString("en-us", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "America/New_York",
      });
      const time = dateEnd.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
      });
      if (dateEls) {
        dateEls.innerHTML = "";
        dateEls.innerHTML = date + ", " + time + " " + timeZoneAbbreviation;
      }
    });
  }
  setBidCount(auction_id, bidsCount) {
    const auctionCards = document.querySelectorAll(
      `[data-auction-id="${auction_id}"]`
    );
    auctionCards.forEach((card) => {
      const bidCountEl = card.querySelector(".bid-count");
      if (bidCountEl) {
        bidCountEl.innerHTML = "";
        if (bidsCount == 1) {
          bidCountEl.innerHTML = bidsCount + " BID";
        } else {
          bidCountEl.innerHTML = bidsCount + " BIDS";
        }
      }
    });
  }
  setCurrentPrice(auction_id, currentPrice, auctionEnded) {
    const auctionCards = document.querySelectorAll(
      `[data-auction-id="${auction_id}"]`
    );
    auctionCards.forEach((card) => {
      if (card) {
        const priceElement = card.querySelector(".card_product__price");
        if (priceElement) {
          priceElement.innerHTML = `$ ${currentPrice.toLocaleString("en-US")}`;
          // After auction ended, hammer price text line-through in PLP & PDP
          if (auctionEnded) {
            priceElement.style.textDecoration = "line-through";
            priceElement.nextElementSibling.style.textDecoration =
              "line-through";
          }
        }
      }
    });
  }
  hidePlaceBidButton(auction_id) {
    const auctionCards = document.querySelectorAll(
      `[data-auction-id="${auction_id}"]`
    );
    auctionCards.forEach((card) => {
      if (card) {
        const bidButton = card.querySelector("button.place_bid");
        if (bidButton) bidButton.remove();
      }
    });
  }
  getDateDiffInDHM(startDate, endDate) {
    const diffMs = Math.abs(endDate.getTime() - startDate.getTime());
    const totalSeconds = Math.floor(diffMs / 1000);
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes - days * 24 * 60) / 60);
    const minutes = totalMinutes - days * 24 * 60 - hours * 60;
    const seconds =
      totalSeconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;
    return { days, hours, minutes, seconds };
  }

  async addProductToWishList(productID, wishlistButton, activeWishListButton) {
    const customerID = window.getCustomerId();

    if (customerID) {
      window.customerApi
        .addToWishList(customerID, productID)
        .then((response) => response.text())
        .then((result1) => {
          window.customerApi
            .getWishList(customerID)
            .then((response) => response.text())
            .then((result) => {
              const wishlistRes = JSON.parse(result1);
              const jsonDATA = JSON.parse(result).data;
              const productCount = jsonDATA.products_count;
              if (!wishlistRes.success) {
                window.showToast("error", {
                  title: "Failed Attempt",
                  message:
                    "A backend error occurred, please reach out to support",
                });
                return;
              }
              document
                .querySelectorAll(".swym-wish-counter")
                .forEach((element) => {
                  element.innerHTML = productCount == 0 ? "" : productCount;
                });

              wishlistButton.classList.add("hidden");
              activeWishListButton.classList.remove("hidden");
            });
        })
        .catch((error) => console.log("error", error));
    } else {
      const section = document.querySelector("#signin");
      section.scrollIntoView;
    }
  }
  async removeFromWishList(productID, wishlistButton, activeWishListButton) {
    const customerID = window.getCustomerId();
    if (customerID) {
      window.customerApi
        .removeFromWishList(customerID, productID)
        .then((response) => response.text())
        .then(() => {
          window.customerApi
            .getWishList(customerID)
            .then((response) => response.text())
            .then((result) => {
              const jsonDATA = JSON.parse(result).data;
              const productCount = jsonDATA.products_count;
              document
                .querySelectorAll(".swym-wish-counter")
                .forEach((element) => {
                  element.innerHTML = productCount == 0 ? "" : productCount;
                });
              wishlistButton.classList.remove("hidden");
              activeWishListButton.classList.add("hidden");
              const template = document.querySelector("wishlist-template");
              if (template) {
                const wishlistItemsCount = document.querySelector(
                  ".wishlistItemsCount"
                );
                const card = document.querySelector(
                  `[data-product-id="${productID}"]`
                );
                card.closest(".grid__item").remove();
                template.applyPagination();
                wishlistItemsCount.innerHTML = "";
                wishlistItemsCount.innerHTML = `${productCount} ${
                  productCount == 1 ? "Item" : "Items"
                }`;
                if (productCount == 0) {
                  const no_products_header = document.createElement("h2");
                  no_products_header.classList.add(
                    "title",
                    "text-center",
                    "no-content"
                  );
                  no_products_header.textContent =
                    "No Products in your favourites list";
                  template.appendChild(no_products_header);
                  const pagination_wrapper = template.querySelector(
                    ".pagination-container"
                  );
                  pagination_wrapper.classList.add("hidden");
                }
              }
            });
        })

        .catch((error) => console.log("error", error));
    } else {
      window.history.pushState({}, null, "/#signin");
    }
  }
}

customElements.define("auctions-card", AuctionsCard);

if (window.getCustomerId()) {
  getWishlist(window.getCustomerId());
}
function wishlistData(customerId) {
  window.customerApi
    .getWishList(customerId)
    .then((response) => response.text())
    .then((data) => {
      // console.log(data);
      return JSON.parse(data).data;
    })
    .catch((error) => console.log(error));
}

async function wishlistCount() {
  const customer_id = getCustomerId();
  if (customer_id) {
    window.customerApi
      .getWishList(customer_id)
      .then((response) => response.text())
      .then((data) => {
        const _wishlistData = JSON.parse(data).data;
        if (_wishlistData) {
          const count = _wishlistData.products_count;
          document.querySelectorAll(".swym-wish-counter").forEach((element) => {
            element.innerHTML = count == 0 ? "" : count;
          });
          if (window.APIrequired) {
            getWishlist(customer_id, _wishlistData);
          }
        }
      })
      .catch((error) => console.log(error));
  }
}
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    document.querySelector("#CartPopup .drawer__close").click();
  }
});
wishlistCount();

function getWishlist(customerId, jsonData) {
  if (jsonData) {
    const jsonProducts = jsonData.products;
    jsonProducts.forEach((item) => {
      const productID = item.shopify_product_id;
      const productCard =
        document.querySelector(
          `auctions-card[data-product-id="${productID}"]`
        ) ||
        document.querySelector(`product-card[data-product-id="${productID}"]`);
      if (productCard) {
        const wishlistBtn = document.querySelector(
          `button[data-action="addToWishlist"][data-product-id="${productID}"]`
        );
        const activeBtn = productCard.querySelector(
          `[data-action="removeToWishlist"][data-product-id="${productID}"]`
        );
        activeBtn.classList.remove("hidden");
        wishlistBtn.classList.add("hidden");
      }
    });
  }
}
const accountPopUp = document.querySelector("#confirm_account_modal");
if (accountPopUp) {
  const sign_upBtn = accountPopUp.querySelector(".button.confirm");
  const registerBtn = accountPopUp.querySelector(".button.closebutton");
  sign_upBtn.addEventListener("click", function (event) {
    event.preventDefault();
    accountPopUp.style.visibility = "hidden";
    const signInModal = document.getElementById("signin");
    signInModal.style.visibility = "visible";
  });
  registerBtn.addEventListener("click", function (event) {
    event.preventDefault();
    accountPopUp.style.visibility = "hidden";
    const signUpModal = document.getElementById("signup");
    signUpModal.style.visibility = "visible";
  });
}

function hideElement(element) {
  if (element) {
    element.classList.add("hidden");
  }
}

function showElement(element) {
  if (element) {
    element.classList.remove("hidden");
  }
}
